import React, { useMemo } from 'react'
import styles from './styles.module.css'
import animations from './animations.module.css'
import IconNewsletter from '../../../static/assets/icon-newsletter.svg'
import IconNewsletterError from '../../../static/assets/icon-newsletter-error.svg'
import IconNewsletterSuccess from '../../../static/assets/icon-newsletter-success.svg'

function NewsletterIcon({ isSuccessfully, isError }) {
  const iconAnimateStyle = useMemo(() => {
    if (isSuccessfully) {
      return animations.success
    }
    if (isError) {
      return animations.error
    }
    return animations.waiting
  }, [isSuccessfully, isError])

  return (
    <div className={styles.icon}>
      <div className={iconAnimateStyle}>
        <IconNewsletterSuccess title="icon-newsletter-success" />
        <IconNewsletter title="icon-newsletter" />
        <IconNewsletterError title="icon-newsletter-error" />
      </div>
    </div>
  )
}

export default NewsletterIcon
